import axios, { AxiosInstance, CreateAxiosDefaults } from "axios";

// 여러 api/*.ts 파일이 "axios.create() + Bearer 토큰 주입 인터셉터"를 각자 복붙해서
// 쓰고 있었다. 응답 처리(unwrap, 에러 매핑)는 파일마다 실제로 다르므로 그대로 두고,
// 완전히 동일했던 요청 인터셉터 부분만 여기로 모은다.
export function createAuthedAxios(config?: CreateAxiosDefaults): AxiosInstance {
  const client = axios.create(config);
  client.interceptors.request.use((requestConfig) => {
    const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    if (token && requestConfig.headers) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  });
  return client;
}
